import React, { useState } from "react";
import { Form, Input, message, Modal } from "antd";
import { HomeRepository } from "../../../../../domain";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { useAppDispatch } from "../../../../../application/store";
import { loadHome } from "../../../../../application/home-slice";

const { useForm, Item } = Form;

type NewSliderItemMoalProps = {
  visible: boolean;
  onClose: () => void;
};

const NewSliderItemMoal: React.FC<NewSliderItemMoalProps> = ({
  visible,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const [form] = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState<File>();

  const closeAndDestroy = () => {
    form.resetFields();
    onClose();
  };

  const submit = async () => {
    try {
      await form.validateFields();
      if (image === undefined) return;
      setIsLoading(true);
      const res = await ServiceLocater.get<HomeRepository>(
        Services.HomeRepository
      ).addSliderItem(form.getFieldValue("link"), image);
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          closeAndDestroy();
          message.success("اسلاید با موفقیت افزوده شد");
          dispatch(loadHome());
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      visible={visible}
      onOk={submit}
      bodyStyle={{ paddingBottom: 0 }}
      title={"اسلاید جدید"}
      closable={!isLoading}
      maskClosable={!isLoading}
      onCancel={isLoading ? undefined : onClose}
      confirmLoading={isLoading}
    >
      <Form form={form}>
        <Item
          name="image"
          label="عکس"
          required
          rules={[{ required: true, validateTrigger: "onSubmit" }]}
        >
          <Input
            name="image"
            type="file"
            onChange={(e) => {
              if (e.target.files !== null) setImage(e.target.files[0]);
            }}
          />
        </Item>
        <Item
          name="link"
          label={"لینک"}
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "string" },
          ]}
        >
          <Input name="link" maxLength={200} />
        </Item>
      </Form>
    </Modal>
  );
};

export default NewSliderItemMoal;
